module.exports = __webpack_public_path__ + "img/图片5.62fa39ea.png";